var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/menu-items/CollapsibleMenuItem.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { css } from "@adornis/chemistry/directives/css.js";
import { html, nothing } from "lit";
import { customElement, state } from "lit/decorators.js";
import { renderMenuItem, renderMenuItemIcon } from "../editor/toolbar/x-editor-toolbar.js";
var CollapsibleMenuItem = class {
  constructor({
    label,
    group,
    menuItems,
    icon
  }) {
    this.isOpen = false;
    this.label = label;
    this.group = group;
    this.menuItems = menuItems;
    this.icon = icon;
    this._menu = document.createElement("collapsible-menu");
    this._menu.addEventListener("mousedown", (e) => {
      e.preventDefault();
    });
    this._menu.label = label;
    this._menu.icon = icon;
    this._menu.menuItems = menuItems;
    this._menu.isOpen = this.isOpen;
  }
  render(view) {
    this._menu.view = view;
    this._menu.isOpen = this.isOpen;
    return html` ${this._menu} `;
  }
  run(editorView) {
    this.isOpen = !this._menu.isOpen;
    this._menu.isOpen = this.isOpen;
  }
};
var CollapsibleMenu = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.isOpen = false;
  }
  render() {
    return html`
      <x-flex horizontal crossaxis-center space="sm" wrap ${css({ borderBottom: this.isOpen ? "2px solid #333" : "" })}>
        ${renderMenuItemIcon({ view: this.view, isActive: this.isOpen, icon: this.icon, run: () => {
    } })}
        ${this.isOpen ? html`
              <x-flex
                horizontal
                crossaxis-center
                space="sm"
                wrap
                @click=${(e) => {
      e.preventDefault();
      e.stopPropagation();
      this.requestUpdate();
    }}
              >
                ${this.menuItems.map((item) => renderMenuItem(item, this.view))}
              </x-flex>
            ` : nothing}
      </x-flex>
    `;
  }
  styles() {
    return [
      ...super.styles(),
      {
        ":host": {}
      }
    ];
  }
};
__decorateClass([
  state()
], CollapsibleMenu.prototype, "isOpen", 2);
CollapsibleMenu = __decorateClass([
  customElement("collapsible-menu")
], CollapsibleMenu);
export {
  CollapsibleMenu,
  CollapsibleMenuItem
};
